import React from 'react';
import InputMask from 'react-input-mask';
import Proptypes from 'prop-types';

function MaskedInput({ value, onChange }) {
  return (
    <InputMask
      mask="999.999.999-99"
      placeholder="&#xf007;  000.000.000-00"
      style={{ fontFamily: 'FontAwesome' }}
      value={value}
      onChange={onChange}
    />
  );
}

MaskedInput.propTypes = {
  value: Proptypes.string.isRequired,
  onChange: Proptypes.func.isRequired,
};

export default MaskedInput;
